import { DEFAULT_BORDER } from '../borderStyles';
import { sharedDefaults } from '../../theme/styleSchema';

/**
 * Schéma de style du Volet (cf. shared/theme/styleSchema) : ses réglages,
 * côté document comme côté site. Le document et le site rangent les communs
 * sous les mêmes noms ; un réglage qui divergerait porterait sa conversion ici
 * (`classic`), comme ceux du Tableau.
 *
 * `openBehavior` (une seule ouverte à la fois) n'a de sens que sur le SITE —
 * un volet imprimé est toujours déplié : comme l'alignement, seul un style du
 * thème le pose.
 *
 * Défauts en fonctions : `border` est un objet, chaque style a le sien.
 */
export const ACCORDION_PANEL_STYLE_SCHEMA = {
  // Gris très léger (gray-0) + réponse blanche : lisibilité par défaut.
  panelColor: { default: '#f8f9fa' },
  answerBackground: { default: '#ffffff' },
  border: { default: () => ({ ...DEFAULT_BORDER }) },
  /** Clé de l'échelle d'ombre (`shared/boxes/shadowStyles`). */
  shadow: { default: 'none' },

  // Site seul, posés par un style du thème : tout ce que règle l'inspecteur.
  openBehavior: { style: 'theme', only: 'site' },
  alignHorizontal: { style: 'theme', seed: true, only: 'site' },
  alignVertical: { style: 'theme', seed: true, only: 'site' },
  /** Style par défaut des textes, par rôle (`question`, `answer`). */
  textStyles: { style: 'theme', only: 'site' },

  // Document seul : la couleur de départ de chaque texte Draft.js. Sur le
  // site, c'est le HTML produit qui porte les couleurs.
  questionColor: { style: false, only: 'document', default: '' },
  answerColor: { style: false, only: 'document', default: '' },
};

/** Props du Volet communes au document et au site. */
export function accordionPanelSharedProps() {
  return sharedDefaults(ACCORDION_PANEL_STYLE_SCHEMA);
}

/**
 * Défauts du BLOC WEB : les props communes, plus ce qui n'appartient qu'au
 * site. SOURCE UNIQUE de sa config Puck.
 */
export function accordionPanelDefaultProps() {
  return {
    question: '',
    answer: '',
    ...accordionPanelSharedProps(),
    openBehavior: 'exclusive',
    alignHorizontal: 'center',
    alignVertical: 'center',
  };
}

/**
 * Props d'un volet complétées par les défauts. À passer devant toute lecture
 * qui compare ou qui convertit : un volet enregistré avant l'ajout d'une prop
 * ne la porte pas (README webviewer §4).
 */
export function normalizeAccordionPanelProps(props) {
  return { ...accordionPanelDefaultProps(), ...(props || {}) };
}

/**
 * Le style d'un volet dans une liste de styles de volets, ou le style par
 * défaut si l'identifiant n'y est pas — c'est le cas d'un volet venu d'une
 * section liée dont la configuration n'a pas été reprise.
 *
 * Ici plutôt que dans `utils/styles` : le parser en a besoin, et ce dossier
 * n'entraîne ni React ni le store dans son sillage.
 */
export function resolveAccordionPanelStyle(styles, styleId) {
  const list = styles || [];
  return list.find((style) => style.id === styleId) ?? list[0] ?? null;
}
